import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SealinesPipe } from "../../../pipes/sealines/sealines.pipe";

@Component({
  selector: 'app-filter-sealines',
  template: `
        <input type="checkbox" [checked]="isActive">
        <label>{{ filterValue | sealines }} <span class="ng-filter-value-count">({{ count }})</span></label>`,
  styleUrls: [],
  imports: [CommonModule, SealinesPipe],
  standalone: true
})
export class FilterSealinesComponent {
  @Input() isActive = false;
  @Input() viewValue!: string;
  @Input() filterValue!: number;
  @Input() count!: number;
}
